"use client";

import React from "react";
import Navbar from "@/components/Navbar";
import Footer2 from "@/components/landing-page/Footer2";
import { Shield, Lock, Server } from "lucide-react";

export default function SecurityPage() {
    return (
        <>
            <Navbar isLoggedIn={false} />
            <div className="bg-zinc-950 min-h-screen text-white pt-32 pb-20">
                <div className="max-w-4xl mx-auto px-6">
                    <h1 className="text-4xl md:text-5xl font-bold mb-8">Security at Senera Core</h1>
                    <p className="text-xl text-zinc-400 mb-12">
                        We treat your data with the same level of security and care as our own. Our platform is built on enterprise-grade security infrastructure.
                    </p>

                    <div className="grid md:grid-cols-3 gap-8 mb-16">
                        <div className="bg-zinc-900/50 p-6 rounded-2xl border border-zinc-800 text-center">
                            <div className="w-12 h-12 bg-zinc-800 rounded-full flex items-center justify-center mx-auto mb-4">
                                <Shield className="w-6 h-6 text-cyan-500" />
                            </div>
                            <h3 className="text-white font-bold mb-2">SOC 2 Type II</h3>
                            <p className="text-sm text-zinc-400">We are fully compliant with SOC 2 Type II standards for security, availability, and confidentiality.</p>
                        </div>
                        <div className="bg-zinc-900/50 p-6 rounded-2xl border border-zinc-800 text-center">
                            <div className="w-12 h-12 bg-zinc-800 rounded-full flex items-center justify-center mx-auto mb-4">
                                <Lock className="w-6 h-6 text-cyan-500" />
                            </div>
                            <h3 className="text-white font-bold mb-2">End-to-End Encryption</h3>
                            <p className="text-sm text-zinc-400">All data is encrypted in transit using TLS 1.3 and at rest using AES-256.</p>
                        </div>
                        <div className="bg-zinc-900/50 p-6 rounded-2xl border border-zinc-800 text-center">
                            <div className="w-12 h-12 bg-zinc-800 rounded-full flex items-center justify-center mx-auto mb-4">
                                <Server className="w-6 h-6 text-cyan-500" />
                            </div>
                            <h3 className="text-white font-bold mb-2">Data Residency</h3>
                            <p className="text-sm text-zinc-400">Enterprise customers can choose their data residency region (US, EU, or APAC).</p>
                        </div>
                    </div>

                    <div className="prose prose-invert prose-lg text-zinc-400 max-w-none">
                        <h3>Vulnerability Disclosure</h3>
                        <p>
                            If you believe you have found a security vulnerability in Senera Core, please report it to our security team at <a href="mailto:security@seneracore.com" className="text-cyan-400">security@seneracore.com</a>.
                        </p>
                    </div>
                </div>
            </div>
            <Footer2 />
        </>
    );
}
